import { Definition, DefinitionList } from '@apex/component-library'
import { Box, Text } from '@chakra-ui/react'
import React from 'react'
import { MarginDetails as IMarginDetails } from '../../../../types'
import {
  numberToCurrency,
  CurrencyEnum,
} from '../../../../utils/numberToCurrency'

export interface MarginDetailsProps {
  marginDetails: IMarginDetails
}

const MarginDetails = ({ marginDetails }: MarginDetailsProps) => {
  const {
    cashEquity,
    cashExcessEquity,
    marginExcessEquity,
    marginEquity,
    totalEquity,
    errors,
  } = marginDetails

  const hasError = errors.length > 0
  return (
    <Box>
      <Box bg="gray.600" color="apex.white" p={3}>
        <Text fontWeight="bold">Margin Details</Text>
      </Box>
      <Box bg="apex.white">
        <DefinitionList>
          <Definition
            term={'Cash Equity'}
            definition={
              !hasError && cashEquity
                ? numberToCurrency(cashEquity, CurrencyEnum.usd)
                : '—'
            }
          />
          <Definition
            term={'Cash Excess Equity'}
            definition={
              !hasError && cashExcessEquity
                ? numberToCurrency(cashExcessEquity, CurrencyEnum.usd)
                : '—'
            }
          />
          <Definition
            term={'Margin Excess Equity'}
            definition={
              !hasError && marginExcessEquity
                ? numberToCurrency(marginExcessEquity, CurrencyEnum.usd)
                : '—'
            }
          />
          <Definition
            term={'Margin Equity'}
            definition={
              !hasError && marginEquity
                ? numberToCurrency(marginEquity, CurrencyEnum.usd)
                : '—'
            }
          />
          <Definition
            term={'Total Equity'}
            definition={
              !hasError && totalEquity
                ? numberToCurrency(totalEquity, CurrencyEnum.usd)
                : '—'
            }
          />
        </DefinitionList>
      </Box>
    </Box>
  )
}

export default MarginDetails
